import {
    USER_PROFILE_READ_REQUEST,
    USER_PROFILE_READ_SUCCESS,
    USER_PROFILE_READ_ERROR,
    USER_PROFILE_UPDATE_REQUEST,
    USER_PROFILE_UPDATE_SUCCESS,
    USER_PROFILE_UPDATE_ERROR,
} from "store/actionTypes";

const initalState = {
    isLoading: false,
    isError: false,
    isUpdating: false,
    message: null,
};

export const reducer = (state = initalState, action) => {
    switch (action.type) {
        case USER_PROFILE_READ_REQUEST:
            state = {
                ...state,
                isLoading: true,
                isError: false,
                isUpdating: false,
                message: null,
            };
            break;
        case USER_PROFILE_READ_SUCCESS:
            state = {
                ...state,
                data: action.data,
                isLoading: false,
                isError: false,
                message: null,
            };
            break;
        case USER_PROFILE_READ_ERROR:
            state = {
                ...state,
                isLoading: false,
                isError: true,
                message: action.message,
            };
            break;
        case USER_PROFILE_UPDATE_REQUEST:
            state = {
                ...state,
                isError: false,
                isUpdating: true,
                message: null,
            };
            break;

        case USER_PROFILE_UPDATE_SUCCESS:
            state = {
                ...state,
                data: action.passThroughData.data,
                isUpdating: false,
                message: action.data.responseMessage,
            };
            break;

        case USER_PROFILE_UPDATE_ERROR:
            state = {
                ...state,
                isUpdating: false,
                isError: true,
                message: action.message,
            };
            break;
        default:
            break;
    }

    return state;
};
